import { useEffect, useState } from "react";
import { viacepService } from "../../../services/cep/viacep.service";
import { FaRegBuilding } from "react-icons/fa";
import { useAuth } from "../../../contexts/AuthContext";
import Alert from "../../shared/alert/Alert";
import Style from "../index.module.css";

export default function Step1({ formData, handleChange, errors, nextStep }) {
  const { user } = useAuth();

  const servicosPossiveis = {
    "Matéria-Prima": [
      "MDF / MDP",
      "Bobinas Aço",
      "Ferragens (parafusos, dobradiças, cantoneiras, corrediças, pregos, rebites etc.)",
      "Colas e adesivos industriais",
      "Tintas, vernizes e solventes",
      "Vidros e espelhos",
      "Plásticos e polímeros injetados",
      "Acessórios de montagens (pés, puxadores, perfis de alumínio etc.)",
      "Produtos Químicos para tratamentos de superfícies ferrosas",
      "Resinas, malhas, catalizadores, gel (matéria prima mármore sintético)"
    ],
    "Material de Consumo": [
      "Abrasivos (lixas, discos de cortes etc)",
      "Equipamentos de proteção individual (EPIs)",
      "Ferramentas em geral",
      "Materiais de limpeza",
      "Itens de escritório",
      "Manutenção Industrial",
      "Uniformes",
      "Brinde e material para divulgação de marketing",
      "Químicos",
      "Viagens, hospedagens e locação de veículos",
      "Informática"
    ],
    "Embalagens": [
      "Papelão: caixas e cantoneiras",
      "Plásticos: sacos, sacos de ráfia, bobinas, stretch, filme termoencolhível",
      "Etiquetas: fitas adesivas, etiquetas em rolo, Ribon",
      "Isomantas: bobinas e perfis",
      "Isopor: placas, cantoneiras"
    ]
  };

  const [tipoPessoa, setTipoPessoa] = useState(formData.tipoPessoa || "JURIDICA");
  const [tipoServico, setTipoServico] = useState(formData.tipoServico || "");
  const [servicoSelecionado, setServicoSelecionado] = useState(formData.servicoSelecionado || "");

  useEffect(() => {
    setTipoServico(formData.tipoServico || "");
    setServicoSelecionado(formData.servicoSelecionado || "");
  }, [formData.tipoServico, formData.servicoSelecionado]);


  const handleTipoPessoaChange = (e) => {
    const tipo = e.target.value;
    setTipoPessoa(tipo);
    handleChange("cpfcnpj", "", tipo);
    handleChange("tipoPessoa", tipo, tipo);
  };

  const handleTipoServicoChange = (e) => {
    const tipo = e.target.value;
    setTipoServico(tipo);
    setServicoSelecionado("");
    handleChange("tipoServico", tipo, tipoPessoa);
    handleChange("servicoSelecionado", tipo, tipoPessoa);
  };

  const handleServicoChange = (e) => {
    const servico = e.target.value;
    setServicoSelecionado(servico);
    handleChange("servicoSelecionado", servico, tipoPessoa);
  };

  const preencherEndereco = async (cep) => {
    try {
      const dados = await viacepService.buscaCep(cep);
      if (dados && !dados.erro) {
        handleChange("endereco", dados.logradouro, tipoPessoa);
        handleChange("cidade", dados.localidade, tipoPessoa);
        handleChange("uf", dados.uf, tipoPessoa);
        handleChange("bairro", dados.bairro, tipoPessoa);
      } else {
        Alert({
          title: "Erro",
          message: `Não foi possível buscar o CEP inserido.`,
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "OK"
        });
      }
    } catch (error) {
      const message = error.response?.data?.erro || error.message;

      await Alert({
        title: "Erro",
        message: `Erro ao buscar CEP: ${message}`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "OK"
      });
    }
  };

  return (
    <div className={Style.step}>
      <h2 style={{ marginBottom: "4px" }}><FaRegBuilding style={{ marginRight: "8px" }} /> Dados da Empresa</h2>
      <p style={{ fontSize: "10pt", marginBottom: "8px" }}>Informe os dados da sua empresa.</p>

      <select
        name="tipoPessoa"
        value={tipoPessoa}
        disabled={(user?.tipusu === "FORNECEDOR" && (user?.status === "PRIMEIRO_ACESSO" || user?.status === "QUESTIONARIO_PENDENTE")) ? true : false}
        onChange={(e) => {
          handleTipoPessoaChange(e);
        }}
      >
        <option value="" disabled>Selecione a pessoa *</option>
        <option value="FISICA">Pessoa Física</option>
        <option value="JURIDICA">Pessoa Jurídica</option>
      </select>

      <input
        type="text"
        name="cpfcnpj"
        disabled={(user?.tipusu === "FORNECEDOR" && (user?.status === "PRIMEIRO_ACESSO" || user?.status === "QUESTIONARIO_PENDENTE")) ? true : false}
        placeholder={tipoPessoa === "JURIDICA" ? "Digite seu CNPJ *" : "Digite seu CPF *"}
        value={formData.cpfcnpj || ""}
        onChange={(e) => handleChange("cpfcnpj", e.target.value, tipoPessoa)}
      />
      {errors.cpfcnpj && <span className="error">{errors.cpfcnpj}</span>}

      <input
        type="text"
        name="razaoSocial"
        disabled={(user?.tipusu === "FORNECEDOR" && (user?.status === "PRIMEIRO_ACESSO" || user?.status === "QUESTIONARIO_PENDENTE") && formData?.razaoSocial !== '') ? true : false}
        placeholder="Digite a Razão Social *"
        value={formData.razaoSocial || ""}
        onChange={(e) => handleChange("razaoSocial", e.target.value, tipoPessoa)}
      />
      {errors.razaoSocial && <span className="error">{errors.razaoSocial}</span>}

      <input
        type="text"
        name="nomeFantasia"
        placeholder="Digite o Nome Fantasia *"
        value={formData.nomeFantasia || ""}
        onChange={(e) => handleChange("nomeFantasia", e.target.value, tipoPessoa)}
      />
      {errors.nomeFantasia && <span className="error">{errors.nomeFantasia}</span>}

      <input
        type="text"
        name="inscricaoEstadual"
        disabled={(user?.tipusu === "FORNECEDOR" && (user?.status === "PRIMEIRO_ACESSO" || user?.status === "QUESTIONARIO_PENDENTE") && formData?.inscricaoEstadual !== '') ? true : false}
        placeholder={tipoPessoa === "JURIDICA" ? "Digite a Inscrição Estadual *" : "Digite o RG *"}
        value={formData.inscricaoEstadual || ""}
        onChange={(e) => handleChange("inscricaoEstadual", e.target.value, tipoPessoa)}
      />
      {errors.inscricaoEstadual && <span className="error">{errors.inscricaoEstadual}</span>}


      <select value={tipoServico} onChange={handleTipoServicoChange}>
        <option value="" disabled>Selecione o tipo de serviço *</option>
        {Object.keys(servicosPossiveis).map((tipo) => (
          <option key={tipo} value={tipo}>{tipo}</option>
        ))}
      </select>

      {tipoServico && (
        <select value={servicoSelecionado} onChange={handleServicoChange}>
          <option value="" disabled>Selecione o serviço *</option>
          {servicosPossiveis[tipoServico].map((serv) => (
            <option key={serv} value={serv}>{serv}</option>
          ))}
        </select>
      )}
      {errors.servicoSelecionado && <span className="error">{errors.servicoSelecionado}</span>}

      <input
        type="text"
        name="cep"
        placeholder="Digite o CEP *"
        value={formData.cep || ""}
        onChange={(e) => handleChange("cep", e.target.value, tipoPessoa)}
        onBlur={(e) => { if (e.target.value.length === 9) preencherEndereco(e.target.value); }}
      />
      {errors.cep && <span className="error">{errors.cep}</span>}

      <input
        type="text"
        name="uf"
        placeholder="Digite a UF *"
        value={formData.uf || ""}
        onChange={(e) => handleChange("uf", e.target.value, tipoPessoa)}
      />
      {errors.uf && <span className="error">{errors.uf}</span>}

      <input
        type="text"
        name="bairro"
        placeholder="Digite o Bairro *"
        value={formData.bairro || ""}
        onChange={(e) => handleChange("bairro", e.target.value, tipoPessoa)}
      />
      {errors.bairro && <span className="error">{errors.bairro}</span>}

      <input
        type="text"
        name="endereco"
        placeholder="Digite o Endereço *"
        value={formData.endereco || ""}
        onChange={(e) => handleChange("endereco", e.target.value, tipoPessoa)}
      />
      {errors.endereco && <span className="error">{errors.endereco}</span>}

      <input
        type="text"
        name="cidade"
        placeholder="Digite a Cidade *"
        value={formData.cidade || ""}
        onChange={(e) => handleChange("cidade", e.target.value, tipoPessoa)}
      />
      {errors.cidade && <span className="error">{errors.cidade}</span>}

      <div className={Style.buttonGroup}>
        <button
          type="button"
          className={`${Style.button} ${Style.buttonPrimary}`}
          onClick={nextStep}
        >
          Próximo
        </button>
      </div>
    </div>
  );
}


